import React, { useState } from "react";
import { IM_DOING, QUOTES, WORDS } from "../constant/global";
import { convertUriIcon } from "../utils/GlobalFunc";
import { CgCloseR } from "react-icons/cg";
import { HeaderSection } from "../components/Headers/HeaderSection";

export default function About() {
  const [activeTesti, setActiveTesti] = useState("");

  return (
    <article className="about active" data-page="about">
      <HeaderSection title="About" />
      <section className="about-text">
        <p>{WORDS.aboutTitle}</p>
      </section>
      <section className="service">
        <h3 className="h3 service-title">What i'm doing</h3>
        <ul className="service-list">
          {IM_DOING?.map((x) => (
            <li className="service-item" key={x.title}>
              <div className="service-icon-box">
                <img src={convertUriIcon(x.img)} alt="design icon" width={40} />
              </div>
              <div className="service-content-box">
                <h4 className="h4 service-item-title">{x.title}</h4>
                <p className="service-item-text">{x.desc}</p>
              </div>
            </li>
          ))}
        </ul>
      </section>
      <section className="testimonials">
        <h3 className="h3 testimonials-title">Quotes:</h3>
        <ul className="testimonials-list has-scrollbar">
          {QUOTES?.map((x) => (
            <li
              className="testimonials-item"
              onClick={() => setActiveTesti(x)}
              key={x.name}
            >
              <div className="content-card" data-testimonials-item>
                <figure className="testimonials-avatar-box">
                  <img
                    src={x.img}
                    alt="Daniel lewis"
                    width={60}
                    data-testimonials-avatar
                  />
                </figure>
                <h4
                  className="h4 testimonials-item-title"
                  data-testimonials-title
                >
                  {x.name}
                </h4>
                <div className="testimonials-text" data-testimonials-text>
                  <p>{x.desc}</p>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </section>
      <div
        className={`modal-container ${activeTesti ? "active" : ""}`}
        data-modal-container
      >
        <div className="overlay" data-overlay />
        <section className="testimonials-modal">
          <button
            className="modal-close-btn"
            onClick={() => setActiveTesti("")}
          >
            <CgCloseR />
          </button>
          <div className="modal-img-wrapper">
            <figure className="modal-avatar-box">
              <img
                src={activeTesti.img}
                alt={activeTesti.name}
                width={80}
                data-modal-img
              />
            </figure>
            {/* <img src="../../public/images/icon-quote.svg" alt="quote icon" /> */}
          </div>
          <div className="modal-content">
            <h4 className="h3 modal-title" data-modal-title>
              {activeTesti.name}
            </h4>
            <time dateTime="2021-06-14">{activeTesti.date}</time>
            <div data-modal-text>
              <p>{activeTesti.desc}</p>
            </div>
          </div>
        </section>
      </div>
      {/* <section className="clients">
                <h3 className="h3 clients-title">Partners:</h3>
                <ul className="clients-list has-scrollbar">
                {CLIENTS?.map((x) => (
                    <li className="clients-item" key={x.name}>
                        <button href={x.img}>
                            <img src={convertUriImg("clients/" + x.img)} alt={x.name} />
                        </button>
                    </li>
                ))}
                </ul>
            </section> */}
    </article>
  );
}
